import React from 'react'
import {
  change as changeFieldValue, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DadosConfiguracaoBPE from './DadosConfiguracaoBPE';
import EnderecoConfiguracaoBPe from './EnderecoConfiguracaoBPe';


export class ModalCadastrarConfiguracaoBPe extends React.Component {
  constructor (props) {
    super(props);
    this.proximaPagina = this.proximaPagina.bind(this);
    this.paginaAnterior = this.paginaAnterior.bind(this);
    this.fechar = this.fechar.bind(this);
    this.state = { paginaAtual: 1, arquivo: null };
  }

  fechar () {
    this.setState({ paginaAtual: 1 });
    this.limparFormulario();
  }

  limparFormulario () {
    this.props.destroy();
    this.props.reset('formCadastrarConfiguracaoBPe');
    this.setState({ perfisSelecionados: [] });
    this.props.selecionarOrigem(null);
    this.props.selecionarOrigem(null);
    this.removeArquivo()
  }


  proximaPagina () {
    this.setState({ paginaAtual: this.state.paginaAtual + 1 })
  }

  paginaAnterior () {
    this.setState({ paginaAtual: this.state.paginaAtual - 1 })
  }

  adicionaArquivo (file) {
    this.setState({ arquivo: file })
  }

  removeArquivo () {
    this.setState({ arquivo: null})   
  }

  exibePaginaAtual () {
    if (this.state.paginaAtual === 1) {
      return <DadosConfiguracaoBPE
        onSubmit={this.proximaPagina}
        seHabilitadaBPe={this.props.seHabilitadaBPe}
        adicionaArquivo={this.adicionaArquivo.bind(this)}
        removeArquivo = {this.removeArquivo.bind(this)}
        limparCampos = {this.fechar.bind(this)}
        paginaAnterior={this.paginaAnterior}
        selecionaregimeTributario= {this.props.selecionaregimeTributario}/>
    }
    if (this.state.paginaAtual === 2) {
      return <EnderecoConfiguracaoBPe
        paginaAnterior={this.paginaAnterior}
        selecionarOrigem={this.props.selecionarOrigem}
        codigoEmpresaSelecionada={this.props.codigoEmpresaSelecionada}
        cidade={this.props.cidade}
        arquivo={this.state.arquivo}
        montarParametroConfiguracao={this.props.montarParametroConfiguracao}
        proximaPagina = {this.proximaPagina}
        regimeTributario = {this.props.regimeTributario}
        limparCampos = {this.fechar.bind(this)}/>
    }

  }

  render () {
    return (
      <div className="modal fade show" id='modalCadastrarConfiguracaoBPe' role='dialog'
           aria-labelledby='modalCadastrarConfiguracaoBPe' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              {/* eslint-disable-next-line no-undef */}
              <h5>{this.props.idEmpresa ? 'Editar Configuração BPe' : 'Nova Configuração BPe'}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={() => this.fechar() }>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            {this.exibePaginaAtual()}
          </div>
        </div>
      </div>
    )
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue
  }, dispatch)
);

export default connect(mapDispatchToProps)(reduxForm({
  form: 'formCadastrarConfiguracaoBPe',
})(ModalCadastrarConfiguracaoBPe));
